import layoutAdmin from '@/layouts/layoutAdmin.vue';

//Item Master Data
import brandSetup from '@/views/module/inventory/settingsManagement/brandSetup.vue';
import categorySetup from '@/views/module/inventory/settingsManagement/categorySetup.vue';
import colorSetup from '@/views/module/inventory/settingsManagement/colorSetup.vue';
import manufactureSetup from '@/views/module/inventory/settingsManagement/manufactureSetup.vue';
import productTypeSetup from '@/views/module/inventory/settingsManagement/productTypeSetup.vue';
import secondaryUnitSetup from '@/views/module/inventory/settingsManagement/secondaryUnitSetup.vue';
import sizeSetup from '@/views/module/inventory/settingsManagement/sizeSetup.vue';
import subCategorySetup from '@/views/module/inventory/settingsManagement/subCategorySetup.vue';
import unitSetup from '@/views/module/inventory/settingsManagement/unitSetup.vue';
import warehouseSetup from '@/views/module/inventory/settingsManagement/warehouseSetup.vue';
import productMapSetup from '@/views/module/inventory/productManagement/productMapSetup.vue';
import purpose from '@/views/module/resource/purpose/purpose.vue';

import supplierTypeSetup from '@/views/module/inventory/supplierManagement/supplierTypeSetup.vue';
import supplierList from '@/views/module/inventory/supplierManagement/supplierList.vue';
import supplierMapSetup from '@/views/module/inventory/supplierManagement/supplierMapSetup.vue';
import customerTypeSetup from '@/views/module/inventory/customerManagement/customerTypeSetup.vue';
import customerList from '@/views/module/inventory/customerManagement/customerList.vue';
import customerMapSetup from '@/views/module/inventory/customerManagement/customerMapSetup.vue';
import lcBankList from '@/views/module/lc/settingsManagement/lcBankList.vue';
import lcPaymentTermList from '@/views/module/lc/settingsManagement/lcPaymentTermList.vue';
import lcIncotermList from '@/views/module/lc/settingsManagement/lcIncotermList.vue';
import lcShippingMethodList from '@/views/module/lc/settingsManagement/lcShippingMethodList.vue';
import lcTypeList from '@/views/module/lc/settingsManagement/lcTypeList.vue';
import lcDocumentTypeList from '@/views/module/lc/settingsManagement/lcDocumentTypeList.vue';
import lcExchangeRateList from '@/views/module/lc/settingsManagement/lcExchangeRateList.vue';
import lcPortList from '@/views/module/lc/settingsManagement/lcPortList.vue';
import assetsDepreciationList from '@/views/module/assets/settingsManagement/assetsDepreciationList.vue';
import assetsCategoriesSetup from '@/views/module/assets/settingsManagement/assetsCategoriesSetup.vue';
import assetsLocationsSetup from '@/views/module/assets/settingsManagement/assetsLocationsSetup.vue';
import assetsStatusTypesSetup from '@/views/module/assets/settingsManagement/assetsStatusTypesSetup.vue';
import armDepartmentSetup from '@/views/module/hrm/settingsManagement/hrmDepartmentSetup.vue';
import hrmDesignationSetup from '@/views/module/hrm/settingsManagement/hrmDesignationSetup.vue';
import hrmEmployeeHODSetup from '@/views/module/hrm/settingsManagement/hrmEmployeeHODSetup.vue';
import hrmEmployeeBankSetup from '@/views/module/hrm/settingsManagement/hrmEmployeeBankSetup.vue';
import productList from '@/views/module/inventory/productManagement/productList.vue';
import productSetup from '@/views/module/inventory/productManagement/productSetup.vue';
import customerSetup from '@/views/module/inventory/customerManagement/customerSetup.vue';
import supplierSetup from '@/views/module/inventory/supplierManagement/supplierSetup.vue';
import hrmSectionSetup from '@/views/module/hrm/settingsManagement/hrmSectionSetup.vue';
import hrmEmployeeType from '@/views/module/hrm/employeesManagement/hrmEmployeeType.vue';



export default [
    {
      path: '/master-data',
      component: layoutAdmin,
      meta: {
        UserLoggedIn: true,
        breadcrumb: 'Master Data Management',
      },
    children: [
      
        {
          path: "purpose",
          name: "purpose",
          meta: {
            breadcrumb: ['Master Data' , "Purpose"],
          },
          component: purpose,
        },
        {
          path: "supplier-mapping",
          name: "supplier-mapping",
          meta: {
            breadcrumb: ["Supplier", "Supplier Mapping"],
          },
          component: supplierMapSetup,
        },
        {
          path: "customer-type",
          name: "customer-type",
          meta: {
            breadcrumb: ["Customer Management", "Add Customer Type"],
          },
          component: customerTypeSetup,
        },
        {
          path: "customer-list",
          name: "customer-list",
          meta: {
            breadcrumb: ["Customer", "Customer List"],
          },
          component: customerList,
        },
        {
          path: "add-customer",
          name: "add-customer",
          meta: {
            breadcrumb: ["Customer", "Add Customer"],
          },
          component: customerSetup,
        },
        {
          path: "customer-mapping",
          name: "customer-mapping",
          meta: {
            breadcrumb: ["Customer", "Customer Mapping"],
          },
          component: customerMapSetup,
        },


        // Business Partner Master Data

        {
          path: "supplier-type",
          name: "supplier-type",
          meta: {
            breadcrumb: ["Supplier Management", "Add Supplier Type"],
          },
          component: supplierTypeSetup,
        },
        {
          path: "add-supplier",
          name: "add-supplier",
          meta: {
            breadcrumb: ["Supplier", "Add Supplier"],
          },
          component: supplierSetup,
        },
        {
          path: "supplier-list",
          name: "supplier-list",
          meta: {
            breadcrumb: ["Supplier", "Supplier List"],
          },
          component: supplierList,
        },


        //Item Master Data
        {
          path: "add-warehouse",
          name: "add-warehouse",
          meta: {
            breadcrumb: ["Setting", "Add Warehouse"],
          },
          component: warehouseSetup,
        },
        {
          path: "add-brand",
          name: "add-brand",
          meta: {
            breadcrumb: ["Setting", "Add Brand"],
          },
          component: brandSetup,
        },
        {
          path: "add-color",
          name: "add-color",
          meta: {
            breadcrumb: ["Setting", "Add Color"],
          },
          component: colorSetup,
        },
        {
          path: "add-manufacture",
          name: "add-manufacture",
          meta: {
            breadcrumb: ["Setting", "Add Manufacture"],
          },
          component: manufactureSetup,
        },
        {
          path: "add-secondary-unit",
          name: "add-secondary-unit",
          meta: {
            breadcrumb: ["Setting", "Add Secondary Unit"],
          },
          component: secondaryUnitSetup,
        },
        {
          path: "add-unit",
          name: "add-unit",
          meta: {
            breadcrumb: ["Setting", "Add Unit"],
          },
          component: unitSetup,
        },
        {
          path: "add-product-type",
          name: "add-product-type",
          meta: {
            breadcrumb: ["Setting", "Add Product Type"],
          },
          component: productTypeSetup,
        },
        {
          path: "employee-type",
          meta: {
            breadcrumb: ['Employee Type']
          },
          component: hrmEmployeeType,
        },
        {
          path: "add-size",
          name: "add-size",
          meta: {
            breadcrumb: ["Setting", "Add Size"],
          },
          component: sizeSetup,
        },
        {
          path: "add-category",
          name: "add-category",
          meta: {
            breadcrumb: ["Setting", "Add Category"],
          },
          component: categorySetup,
        },
        {
          path: "add-subcategory",
          name: "add-subcategory",
          meta: {
            breadcrumb: ["Setting", "Add Category"],
          },
          component: subCategorySetup,
        },

        {
          path: "product-mapping",
          name: "product-mapping",
          meta: {
            breadcrumb: ["Product", "Product Mapping"],
          },
          component: productMapSetup,
        },
        
        {
          path: "banks",
          name: "lc-banks",
          meta: {
            breadcrumb: ["Settings", "LC Banks"],
          },
          component: lcBankList,
      },
        {
        path: "payment-terms",
        name: "lc-payment-terms",
        meta: {
          breadcrumb: ["Settings", "Payment Terms"],
        },
        component: lcPaymentTermList,
      },
        
        {
        path: "incoterm",
        name: "lc-incoterm",
        meta: {
          breadcrumb: ["Settings", "Incoterms"],
        },
        component: lcIncotermList,
      },
        
        {
        path: "shipping-methods",
        name: "lc-shipping-methods",
        meta: {
          breadcrumb: ["Settings", "Shipping Methods"],
        },
        component: lcShippingMethodList,
      },
        {
        path: "types",
        name: "lc-types",
        meta: {
          breadcrumb: ["Settings", "LC Types"],
        },
        component: lcTypeList,
      },
        
        {
        path: "document-types",
        name: "lc-document-types",
        meta: {
          breadcrumb: ["Settings", "Document Types"],
        },
        component: lcDocumentTypeList,
      },
        
        {
        path: "currency-echange-rate",
        name: "lc-currency-echange-rate",
        meta: {
          breadcrumb: ["Settings", "Exchange Rates"],
        },
        component: lcExchangeRateList,
      },
        
        {
        path: "ports",
        name: "lc-ports",
        meta: {
          breadcrumb: ["Settings", "Ports"],
        },
        component: lcPortList,
      },
        
        {
          path: "depreciation-methods-records",
          name: "depreciation-methods-records",
          meta: {
              breadcrumb: ['Depreciation Methods Records']
          },
          component: assetsDepreciationList,
      },
        
        {
          path: "category-records",
          name: "category-records",
          meta: {
              breadcrumb: ['Category Records']
          },
          component: assetsCategoriesSetup,
      },
        
        {
          path: "location-records",
          name: "location-records",
          meta: {
              breadcrumb: ['Location Records']
          },
          component: assetsLocationsSetup,
      },
        
        {
          path: "status-type-records",
          name: "status-type-records",
          meta: {
              breadcrumb: ['Status Type Records']
          },
          component: assetsStatusTypesSetup,
      },
        
        {
          path: "department",
          meta: {
            breadcrumb: ['Department']
          },
          component: armDepartmentSetup,
      },
        
        {
          path: "designation",
          meta: {
            breadcrumb: ['Designation']
          },
          component: hrmDesignationSetup,
      },
        {
          path: "department-head",
          meta: {
            breadcrumb: ['HOD Setup']
          },
          component: hrmEmployeeHODSetup,
      },
      {
          path: "section",
          meta: {
            breadcrumb: ['Section']
          },
          component: hrmSectionSetup,
        },
        {
          path: "employee-bank-setup",
          meta: {
            breadcrumb: ['Employee Bank Setup']
          },
          component: hrmEmployeeBankSetup,
      },

      {
        path: "setup-product",
        name: "setup-product",
        meta: {
          breadcrumb: ["Product", "Add Product"],
        },  
        component: productSetup,
      },
        {
        path: "product-list",
        name: "product-list",
        meta: {
          breadcrumb: ["Product", "Product List"],
        },
        component: productList,
      },
        {
        path: "add-product",
        name: "add-product",
        meta: {
          breadcrumb: ["Product", "Product List"],
        },
        component: productSetup,
      },
      ],
      
    },
    
  ]


  